export const generateQtyLimit = (inventory, purchaseLimit = 0) => {
  if (!!purchaseLimit) {
    return Number(inventory) > Number(purchaseLimit) ? Number(purchaseLimit) : Number(inventory);
  }
  return Number(inventory);
};
